import React from "react";
import { Modal, Spinner } from "react-bootstrap";

const BackdropFSTextLoaderGreen = ({ open }) => {
  return (
    <Modal
      show={open}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="backdrop-spinner"
      backdropClassName="backdrop-spinner-class"
      style={{ zIndex: 1056 }}
    >
      <Spinner animation="border" style={{ color: "#359742" }} />
      <h6 className="pt-1">Loading...</h6>
    </Modal>
  );
};

export default BackdropFSTextLoaderGreen;
